
export default {
  methods : {
    async handleRequestValidationError(errorSlug){
      switch(errorSlug){
        case 'authentication':
          await this.$store.dispatch('authentication/authErrorLogout');

          await this.$store.dispatch({
            type  : 'layouts/updateLoginedView',
            value : false,
          });

          this.$store.dispatch({
            type  : 'layouts/updateMountedLayoutStyleName',
            value : 'front'
          });

          this.$router.push({name: 'index'});
        break;

        case 'emailUnCertificated':
          // emailUnCertificatedの場合はメール認証が完了していないので飛ばします。
          if(this.$route.name !== 'registration.confirmationInfomation.email'){
            await this.$store.dispatch({
              type  : 'layouts/updateLoginedView',
              value : false,
            });
  
            this.$store.dispatch({
              type  : 'layouts/updateMountedLayoutStyleName',
              value : 'front'
            });
            
            this.$router.push({ name: 'registration.confirmationInfomation.email' });
          }
        break;

        case 'ServiceUnavailable':
          if(this.$route.name !== 'serviceUnavailable'){
            await this.$store.dispatch({
              type  : 'layouts/updateLoginedView',
              value : false,
            });
  
            this.$store.dispatch({
              type  : 'layouts/updateMountedLayoutStyleName',
              value : 'front'
            });
            
            this.$router.push({ name: 'serviceUnavailable' });
          }
        break;

        default:
          this.$store.dispatch({
            type        : 'flashMessage/updateFlashMessage',
            hasMessage  : true,
            message     : '&nbsp;魔線接続に外部からの侵入が発生しました。接続を強制停止します。アプリを再読み込みしてください。',
            status      : 'error',
            hasControl  : false,
            autoClose   : false
          }, {root:true});
        break;
      }
    }
  }
}